var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("entity-editor", {
    attrs: {
      entity: "research",
      id: _vm.id,
      "api-name": "researchRequests",
      "new-entity": _vm.newResearchRequest
    },
    on: { isDirtyChange: _vm.handleIsDirtyChange },
    scopedSlots: _vm._u(
      [
        {
          key: `editor`,
          fn: function({ doc }) {
            return [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: { rules: [_vm.requiredRule] },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Reference" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: doc.reference,
                          callback: function($$v) {
                            _vm.$set(doc, "reference", $$v)
                          },
                          expression: "doc.reference"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-select", {
                        attrs: {
                          rules: [_vm.requiredRule],
                          items: _vm.researchPeriods,
                          "item-text": "name",
                          "item-value": "id",
                          disabled: _vm.isLoading,
                          label: "Research Period",
                          outlined: "",
                          dense: ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Research Period" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: doc.researchPeriodId,
                          callback: function($$v) {
                            _vm.$set(doc, "researchPeriodId", $$v)
                          },
                          expression: "doc.researchPeriodId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Player Name", outlined: "" },
                        model: {
                          value: doc.realName,
                          callback: function($$v) {
                            _vm.$set(doc, "realName", $$v)
                          },
                          expression: "doc.realName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Character Name", outlined: "" },
                        model: {
                          value: doc.characterName,
                          callback: function($$v) {
                            _vm.$set(doc, "characterName", $$v)
                          },
                          expression: "doc.characterName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Topic",
                          outlined: "",
                          "auto-grow": ""
                        },
                        model: {
                          value: doc.topic,
                          callback: function($$v) {
                            _vm.$set(doc, "topic", $$v)
                          },
                          expression: "doc.topic"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Notes",
                          rows: "2",
                          outlined: "",
                          "auto-grow": ""
                        },
                        model: {
                          value: doc.notes,
                          callback: function($$v) {
                            _vm.$set(doc, "notes", $$v)
                          },
                          expression: "doc.notes"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Url", outlined: "" },
                        model: {
                          value: doc.url,
                          callback: function($$v) {
                            _vm.$set(doc, "url", $$v)
                          },
                          expression: "doc.url"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }